import type { ModuleFile } from '../../core/modules.ts';

// Módulo «voice»: manifiesto. Las pantallas se cargan de forma perezosa.
export const manifests: ModuleFile['manifests'] = [
  {
    id: 'voice',
    title: 'Voz',
    projectTab: { segment: 'voz', label: 'Voz', order: 3 },
    load: () => import('./VoicePage.tsx').then((m) => ({ default: m.VoicePage })),
  },
];
